//@ts-check
import { error as errorToast } from '@react/react-spectrum/Toast/js/ToastContainer';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import { ContainerContext } from '~/utils';

import getInternalDocument from '../actions/get-internal-document';

/** @param {Pick<import('@action-types/internal-document').InternalDocumentParams, 'appId' | 'appType'>} props */
const useGetInternalDocument = ({ appId, appType }) => {
  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;

  /** @type {import('@tanstack/react-query').UseMutationResult<import('@action-types/internal-document').InternalDocumentResponse, import('@action-types/RequestError').RequestError<import('@action-types/internal-document').InternalDocumentApiErrorResponse>, { uri: string; }>} */
  const data = useMutation({
    mutationFn: ({ uri }) => getInternalDocument({ uri, appId, appType, token }),
    onError: (error) => {
      errorToast(error.message);
    },
    onSuccess(data) {
      window.open(data.url, '_blank', 'noopener,noreferrer');
    },
  });

  return data;
};

export default useGetInternalDocument;
